<template>
  <div class="alert alert-warning fade show d-flex justify-content-center baseAlertMessage" v-if="false">
    <div class="container">
      <div class="alert-text text-white text-center alert__initial__content">
        <BaseIcon type="fas" icon="exclamation-triangle" size="lg" class="mr-2" />
        Important! Tokyo Maintenance &#128295; Saturday 16 Feb - Sunday 17 Feb &#129520; - NEW DATES,
        <span @click="toggleTooltipDisplay">See more...</span>
      </div>
      <div v-if="tooltip" class="alert__tooltip__content">
        <p>Hello TOKYO the server will be temporarily unavailable due to maintenance on:</p>
        <ul>
          <li><strong>London:</strong> Saturday 16th 12pm to Sunday 17th 9pm</li>
          <li><strong>Los Angeles:</strong> Saturday 16th 5am to Sunday 17th 1pm</li>
          <li><strong>Syndey:</strong> Saturday 16th to  Monday 18th 8am</li>
        </ul>
        <p>We will let you know as soon the maintenance is over.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseAlertMessage',
  data() {
    return {
      tooltip: false
    }
  },
  methods: {
    toggleTooltipDisplay() {
      this.tooltip = !this.tooltip
      console.log("toggleTooltipDisplay", this.tooltip)
    }
  }
}
</script>

<style>
.baseAlertMessage {
  border-radius: 0;
  z-index:3;
  font-weight: 400;
  padding: .5rem 1rem;
  text-shadow: 0 0 1px rgba(0, 0, 0, .1);
}
.alert__initial__content {
  padding: .5rem 0;
  color: #111111 !important;
}
.alert__initial__content > p {
  font-weight: 800;
  margin: 0;
}
.alert__initial__content > span {
  cursor: pointer;
  text-decoration: underline;
}
.alert__tooltip__content {
  text-align: left;
  display: block;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffe09e;
  padding: 1rem 2rem;
  border-radius: 5px;
  min-width: 32rem;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 1;
}
.alert__tooltip__content ul {
  padding-left: 1.25rem;
}
.alert__tooltip__content li {
  margin-top: .5rem;
}
</style>
